module.exports = Highcharts;


/*****************
 ** WEBPACK FOOTER
 ** external "Highcharts"
 ** module id = 287
 ** module chunks = 0
 **/